import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = {
  key: 0,
  class: "text-muted font-italic lead"
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "modal-footer" }
const _hoisted_11 = {
  key: 0,
  target: "_blank",
  class: "btn btn-success"
}

import { computed, toRef } from 'vue'
    import { tchMarked } from '@common/Common'

    import type { AlternativeDetailsDialogViewModel } from '@Alternatives/Alternatives/Components/AlternativeDetailsDialog'

    // ---------------- props ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AlternativeDetailsDialog',
  props: {
    viewModel: {}
  },
  setup(__props: any) {

    const props = __props

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const opened = computed(() => vm.value?.opened ?? false)
    const name = computed(() => vm.value.name)
    const description = computed(() => vm.value.description)
    const descriptionHtml = computed(() =>
        description.value ? tchMarked(description.value) : null
    )
    const detailsUrl = computed(() => vm.value.detailsUrl)

    // ---------------- actions ----------------

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, _toDisplayString(name.value) + "​", 1 /* TEXT */),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_7, [
                (!description.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, "No description provided"))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", { innerHTML: descriptionHtml.value }, null, 8 /* PROPS */, _hoisted_9)
              ]),
              _createElementVNode("div", _hoisted_10, [
                (detailsUrl.value)
                  ? _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_11, [...(_cache[0] || (_cache[0] = [
                      _createTextVNode("Details", -1 /* CACHED */)
                    ]))])), [
                      [_directive_sanitizedHref, detailsUrl.value]
                    ])
                  : _createCommentVNode("v-if", true),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Close")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})